var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Divider, Grid, Header, Modal } from "semantic-ui-react";
import { ProKitConfig } from "../../KitDeserializer";
import { ProtocolTypeEnum } from "../automated-pro/EditKitForm";
import { rnaCishAccessionsPopup } from "../automated-pro/ProbeSetForm";
import { displayEncoderScaleLabelForCart } from "../manual-gold-if/EncoderComponentForm";
import { calculateNumOfSamplesForProbe, calculateNumOfSlidesForProbe, displayScaleLabelForCart } from "../secondary-if/ProbeForm";
import { formatMonetaryDecimal } from "./EditKitForm";
import { calculateNumOfSamplesForAmp, calculateNumOfSlidesForAmp } from "./HcrAmplifierForm";
import { AutomatedGoldIfKit, AutomatedGoldIfPricedKit, ManualGoldIfKit, ManualGoldIfPricedKit, ManualProKit, PricedManualProKit, RnaFishKit, RnaFishPricedKit, SecondaryIfKit, SecondaryIfPricedKit, SimpleCatalogVariantProbeSet, SimpleLibraryOrganismCustomTargetProbeSet, SimpleOtherOrganismCustomTargetProbeSet } from "./KitModel";
import { calculateNumOfSamplesForProbeSet, calculateNumOfSlidesForProbeSet, noAccessionsMsg } from "./ProbeSetForm";
var KitDisplay = /** @class */ (function (_super) {
    __extends(KitDisplay, _super);
    function KitDisplay(props) {
        var _this = _super.call(this, props) || this;
        _this.negativeControlProbe = function (legacy, psc, ps, sampleType, priceCents) {
            return React.createElement(Grid, { columns: 4, className: 'tight-rows' },
                React.createElement(Grid.Row, null),
                React.createElement(Grid.Row, null),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { className: 'fluorescent', size: 'small' }, legacy ? "HCR™ Negative Control Probe (v3.0)" : "HCR™ HiFi Negative Control Probe"))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Target"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, ps.probeSetFamily.geneSymbol)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "For use with amplifier"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, ps.hcrAmplifier.id)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Scale"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, displayScaleLabelForCart(calculateNumOfSamplesForProbeSet(psc.scale.scaleValue), calculateNumOfSlidesForProbeSet(psc.scale.scaleValue), legacy ? psc.scale.pmolWithUnits : psc.scale.scaleWithUnits, sampleType))),
                priceCents !== undefined && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, _this.subtotalLabel()),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, _this.subtotalDisplay(priceCents))));
        };
        _this.probeSet = function (legacy, admin, psc, sampleType, priceCents) {
            var rna = psc.probeSet instanceof SimpleCatalogVariantProbeSet ? psc.probeSet.customerSequence : psc.probeSet.target.targetMrnaSeq;
            var accessionsForBlast = psc.probeSet instanceof SimpleCatalogVariantProbeSet
                ? [psc.probeSet.customerAccessionNum]
                : [psc.probeSet.target.accession];
            var copyClickLink = function () { return _this.onCopyClick(rna); };
            var probeSetSizeDisplay;
            if (admin) {
                probeSetSizeDisplay = psc.probeSet instanceof SimpleCatalogVariantProbeSet ?
                    psc.probeSet.variant.probeSetSize + " | " + numOfBindingSitesDisplay(psc.probeSet.customerProbeSetSize) :
                    psc.probeSet.probeSetSize + " | " + numOfBindingSitesDisplay(psc.probeSet.probeSetSize);
            }
            else {
                probeSetSizeDisplay = psc.probeSet instanceof SimpleCatalogVariantProbeSet ?
                    numOfBindingSitesDisplay(psc.probeSet.customerProbeSetSize) :
                    numOfBindingSitesDisplay(psc.probeSet.probeSetSize);
            }
            return React.createElement(Grid, { columns: 4, className: 'tight-rows' },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { className: 'fluorescent', size: 'small' }, legacy ? "HCR™ Probe (v3.0)" : "HCR™ HiFi Probe"))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Organism"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, psc.probeSet instanceof SimpleCatalogVariantProbeSet
                        ? psc.probeSet.customerOrganismName : psc.probeSet.organism.name)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Target"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, psc.probeSet instanceof SimpleCatalogVariantProbeSet
                        ? React.createElement("div", { className: "gene-symbol" }, psc.probeSet.customerTargetName)
                        : React.createElement("div", { className: "gene-symbol" }, psc.probeSet.target.name))),
                admin && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Accession"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, psc.probeSet instanceof SimpleCatalogVariantProbeSet
                        ? accessionSearchLink(psc.probeSet.customerAccessionNum) :
                        accessionSearchLink(psc.probeSet.target.accession))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                        "RNA target sequence (",
                        rna.length,
                        " nt)"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                        abbreviateRnaWithModal(rna, false),
                        "\u00A0",
                        _this.state.copyButtonText === 'Copied!' ? React.createElement("strong", null, "Copied!") :
                            React.createElement("a", { style: { cursor: 'pointer' }, onClick: copyClickLink }, _this.state.copyButtonText),
                        " ",
                        _this.props.displayBlastLink
                            && accessionsForBlast.length > 0
                            && rna.length > 0
                            && React.createElement("a", { href: blastUrl(accessionsForBlast, rna) }, "Blast"))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "For use with amplifier"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, psc.probeSet.hcrAmplifier.id)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "# of binding sites"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, probeSetSizeDisplay)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Scale"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, displayScaleLabelForCart(calculateNumOfSamplesForProbeSet(psc.scale.scaleValue), calculateNumOfSlidesForProbeSet(psc.scale.scaleValue), legacy ? psc.scale.pmolWithUnits : psc.scale.scaleWithUnits, sampleType))),
                priceCents !== undefined && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Price"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                        "$",
                        formatMonetaryDecimal(priceCents))));
        };
        _this.amplifier = function (legacy, amplifier, sampleType, priceCents) {
            return React.createElement(Grid, { className: 'tight-rows' },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { className: 'fluorescent', size: 'small' }, legacy ? "HCR™ Amplifier (v3.0)" : "HCR™ Gold Amplifier"))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Amplifier"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatAmplifierLabel(amplifier))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Scale"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, displayScaleLabelForCart(calculateNumOfSamplesForAmp(amplifier.scale.valuePmol), calculateNumOfSlidesForAmp(amplifier.scale.valuePmol), legacy ? amplifier.scale.valueWithUnit : amplifier.scale.ampConcentratedWithUnit, sampleType))),
                priceCents !== undefined && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Price"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                        "$",
                        formatMonetaryDecimal(priceCents))));
        };
        _this.buffers = function (legacy, buffers, priceCents) {
            return React.createElement(Grid, { className: 'tight-rows' },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { className: 'fluorescent', size: 'small' }, legacy ? "HCR™ Buffers (v3.0)" : "HCR™ Buffers"))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, legacy ? "Probe Hybridization Buffer" : "HiFi Probe Hybridization Buffer"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffers.hybridization.valueWithUnit)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, legacy ? "Probe Wash Buffer" : "HiFi Probe Wash Buffer"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffers.probeWash.valueWithUnit)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, legacy ? "Amplifier Buffer" : "Gold Amplifier Buffer"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffers.ampBuffer.valueWithUnit)),
                !legacy && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Gold Amplifier Wash Buffer"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffers.ampWashBuffer.valueWithUnit)),
                priceCents !== undefined && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Price"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                        "$",
                        formatMonetaryDecimal(priceCents))));
        };
        _this.manualProBuffers = function (buffers, priceCents) {
            return React.createElement(Grid, { className: 'tight-rows' },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { className: 'fluorescent', size: 'small' }, "HCR™ Buffers"))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "HiFi Probe Hybridization Buffer"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffers.hybridizationBuffer.valueWithUnit)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "HiFi Probe Wash Buffer"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffers.probeWashBuffer.valueWithUnit)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Pro Amplifier Wash Buffer"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffers.ampWashBuffer.valueWithUnit)),
                priceCents !== undefined && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Price"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                        "$",
                        formatMonetaryDecimal(priceCents))));
        };
        _this.secondaryIfProbe = function (probe, sampleType, legacy, priceCents) {
            return React.createElement(Grid, { className: 'tight-rows' },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { size: 'small' }, legacy ? "HCR™ Probe" : "HCR™ HiFi 2º Antibody Probe"))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, legacy ? "2º Antibody Probe" : "Host & reactivity"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, probe.probe.name)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "For use with amplifier"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, probe.amplifier.amplifier.id)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Scale"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, displayScaleLabelForCart(calculateNumOfSamplesForProbe(probe.scale.ugram), calculateNumOfSlidesForProbe(probe.scale.ugram), probe.scale.valueWithUnit(), sampleType))),
                priceCents !== undefined && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Price"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                        "$",
                        formatMonetaryDecimal(priceCents))));
        };
        _this.secondaryIfBuffers = function (legacy, buffers, priceCents) {
            return React.createElement(Grid, { className: 'tight-rows' },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { size: 'small' }, "HCR™ Buffers"))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, legacy ? "Antibody Buffer" : "HiFi Antibody Buffer"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffers.antibodyBuffer.valueWithUnit)),
                !legacy && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "HiFi Antibody Wash Buffer"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffers.antibodyWashBuffer.valueWithUnit)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, legacy ? "Amplifier Buffer" : "Gold Amplifier Buffer"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffers.amplificationBuffer.valueWithUnit)),
                !legacy && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Gold Amplifier Wash Buffer"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffers.goldAmpWashBuffer.valueWithUnit)),
                priceCents !== undefined && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Price"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                        "$",
                        formatMonetaryDecimal(priceCents))));
        };
        _this.encoderComponent = function (encoder, sampleType, priceCents) {
            return React.createElement(Grid, { className: 'tight-rows' },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { size: 'small' }, "HCR™ HiFi Encoder"))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "For encoding isotype"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, encoder.encodeA.displayName)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "For use with amplifier"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, encoder.hcrAmplifier.id)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Scale"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, displayEncoderScaleLabelForCart(encoder.scale.slides, encoder.scale.samples, sampleType))),
                priceCents !== undefined && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Price"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                        "$",
                        formatMonetaryDecimal(priceCents))));
        };
        _this.encoderBuffers = function (buffers, priceCents) {
            return React.createElement(Grid, { className: 'tight-rows' },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { size: 'small' }, "HCR™ Buffers"))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "HiFi Antibody Buffer"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffers.antibodyBuffer.valueWithUnit)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "HiFi Antibody Wash Buffer"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffers.antibodyWashBuffer.valueWithUnit)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Gold Amplifier Buffer"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffers.amplificationBuffer.valueWithUnit)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Gold Amplifier Wash Buffer"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffers.ampWashBuffer.valueWithUnit)),
                priceCents !== undefined && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Price"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                        "$",
                        formatMonetaryDecimal(priceCents))));
        };
        _this.consumerRnaCishKit = function (protocolType, config, kit) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25;
            var probes = kit.probeSetComponent;
            var detect = kit.detectComponent;
            var chromogenComponent = kit.chromogenComponent;
            var misc = kit.miscComponent;
            var platformSelection = React.createElement(React.Fragment, null,
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Platform"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                        React.createElement(React.Fragment, null, protocolType.alias))));
            var configurationRow = React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Configuration"),
                React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                    kit.plexity > 1 && kit.plexity + "-plex ",
                    config));
            // Section header shown above each probe / detect channel ("Target", "Target 1", "Channel", "Extras", …)
            var sectionLabel = function (text) { return React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(Header, { className: 'chromogenic', size: 'medium' }, text))); };
            // A standard label / value row used for the detect, newChromogen and misc detail lines
            var detailRow = function (label, value) { return React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, label),
                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, value)); };
            var extraLabel = sectionLabel("Extras");
            var chromogen = _this.chromogenDisplay(chromogenComponent);
            if (config === ProKitConfig.ProbeDetect) {
                return React.createElement(Grid, { columns: 4, className: 'tight-rows' },
                    configurationRow,
                    platformSelection,
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Scale"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, probeScaleLabel(probes[0]))),
                    protocolType.id === ProtocolTypeEnum.ROCHE && detect && _this.prefilledDisplay(detect),
                    probes.map(function (probe, index) { return React.createElement(React.Fragment, { key: probe.channel },
                        sectionLabel(kit.plexity > 1 ? "Target " + probe.channel : "Target"),
                        _this.organismAndTargetDisplay(probe),
                        _this.enzymeDisplay("Enzyme", detect === null || detect === void 0 ? void 0 : detect.channels[index])); }),
                    kit.chromogenComponent !== undefined && React.createElement(React.Fragment, null, chromogen));
            }
            if (config === ProKitConfig.ProbeOnly || config === ProKitConfig.StarterKitProbe) {
                return React.createElement(Grid, { columns: 4, className: 'tight-rows' },
                    configurationRow,
                    platformSelection,
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Scale"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, probeScaleLabel(probes[0]))),
                    probes.map(function (probe) { return React.createElement(React.Fragment, { key: probe.channel },
                        sectionLabel(kit.plexity > 1 ? "Target " + probe.channel : "Target"),
                        _this.organismAndTargetDisplay(probe)); }));
            }
            if (config === ProKitConfig.DetectOnly) {
                return React.createElement(Grid, { columns: 4, className: 'tight-rows' },
                    configurationRow,
                    platformSelection,
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Scale"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, detectScaleLabel(detect))),
                    protocolType.id === ProtocolTypeEnum.ROCHE && detect && _this.prefilledDisplay(detect), detect === null || detect === void 0 ? void 0 :
                    detect.channels.map(function (channel) { return React.createElement(React.Fragment, { key: channel.channel },
                        sectionLabel(kit.plexity > 1 ? "Channel " + channel.channel : "Channel"),
                        _this.enzymeDisplay("Enzyme", channel)); }),
                    kit.chromogenComponent !== undefined && React.createElement(React.Fragment, null, chromogen));
            }
            if (config === ProKitConfig.ExtrasOnly) {
                return React.createElement(Grid, { columns: 4, className: 'tight-rows' },
                    configurationRow,
                    platformSelection,
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Scale"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, chromogenScaleLabel(kit.chromogenComponent))),
                    extraLabel,
                    chromogen);
            }
            else {
                return React.createElement(Grid, { columns: 4, className: 'tight-rows' },
                    configurationRow,
                    platformSelection,
                    probes.map(function (probe) { return React.createElement(React.Fragment, { key: probe.channel }, _this.otherProbeDisplay(sectionLabel(kit.plexity > 1 ? "Target " + probe.channel : "Target"), _this.organismAndTargetDisplay(probe), probe)); }),
                    detect != null && sectionLabel("Detect"), detect === null || detect === void 0 ? void 0 :
                    detect.channels.map(function (channel) {
                        return React.createElement(React.Fragment, { key: channel.channel }, _this.enzymeDisplay(kit.plexity > 1 ? "Enzyme " + channel.channel : "Enzyme", channel));
                    }),
                    detect != null && detect.pretreatADewax.volume.valueUl > 0 &&
                        detailRow(detect.pretreatADewax.label, displayUnits((_c = (_b = (_a = kit.detectComponent) === null || _a === void 0 ? void 0 : _a.presetScale) === null || _b === void 0 ? void 0 : _b.units) !== null && _c !== void 0 ? _c : (_d = kit.detectComponent) === null || _d === void 0 ? void 0 : _d.customScale, "slides")),
                    detect != null && detect.pretreatBAntigenRetrieval.volume.valueUl > 0 &&
                        detailRow(detect.pretreatBAntigenRetrieval.label, displayUnits((_g = (_f = (_e = kit.detectComponent) === null || _e === void 0 ? void 0 : _e.presetScale) === null || _f === void 0 ? void 0 : _f.units) !== null && _g !== void 0 ? _g : (_h = kit.detectComponent) === null || _h === void 0 ? void 0 : _h.customScale, "slides")),
                    detect != null && detect.pretreatBloxol.volume.valueUl > 0 &&
                        detailRow(detect.pretreatBloxol.label, displayUnits((_l = (_k = (_j = kit.detectComponent) === null || _j === void 0 ? void 0 : _j.presetScale) === null || _k === void 0 ? void 0 : _k.units) !== null && _l !== void 0 ? _l : (_m = kit.detectComponent) === null || _m === void 0 ? void 0 : _m.customScale, "slides")),
                    detect != null && detect.detectA.volume.valueUl > 0 &&
                        detailRow(detect.detectA.label, displayUnits((_q = (_p = (_o = kit.detectComponent) === null || _o === void 0 ? void 0 : _o.presetScale) === null || _p === void 0 ? void 0 : _p.units) !== null && _q !== void 0 ? _q : (_r = kit.detectComponent) === null || _r === void 0 ? void 0 : _r.customScale, "slides")),
                    detect != null && detect.detectB.volume.valueUl > 0 &&
                        detailRow(detect.detectB.label, displayUnits((_u = (_t = (_s = kit.detectComponent) === null || _s === void 0 ? void 0 : _s.presetScale) === null || _t === void 0 ? void 0 : _t.units) !== null && _u !== void 0 ? _u : (_v = kit.detectComponent) === null || _v === void 0 ? void 0 : _v.customScale, "slides")),
                    detect != null && detect.detectC.volume.valueUl > 0 &&
                        detailRow(detect.detectC.label, displayUnits((_y = (_x = (_w = kit.detectComponent) === null || _w === void 0 ? void 0 : _w.presetScale) === null || _x === void 0 ? void 0 : _x.units) !== null && _y !== void 0 ? _y : (_z = kit.detectComponent) === null || _z === void 0 ? void 0 : _z.customScale, "slides")), detect === null || detect === void 0 ? void 0 :
                    detect.channels.map(function (channel) {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
                        return React.createElement(React.Fragment, { key: channel.channel },
                            channel.detectAntiHapten.volume.valueUl > 0 &&
                                detailRow(channel.detectAntiHapten.label, displayUnits((_c = (_b = (_a = kit.detectComponent) === null || _a === void 0 ? void 0 : _a.presetScale) === null || _b === void 0 ? void 0 : _b.units) !== null && _c !== void 0 ? _c : (_d = kit.detectComponent) === null || _d === void 0 ? void 0 : _d.customScale, "slides")),
                            channel.detectTyramide.volume.valueUl > 0 &&
                                detailRow(channel.detectTyramide.label, displayUnits((_g = (_f = (_e = kit.detectComponent) === null || _e === void 0 ? void 0 : _e.presetScale) === null || _f === void 0 ? void 0 : _f.units) !== null && _g !== void 0 ? _g : (_h = kit.detectComponent) === null || _h === void 0 ? void 0 : _h.customScale, "slides")),
                            channel.detectEnzymeHrp.volume.valueUl > 0 &&
                                detailRow(channel.detectEnzymeHrp.label, displayUnits((_l = (_k = (_j = kit.detectComponent) === null || _j === void 0 ? void 0 : _j.presetScale) === null || _k === void 0 ? void 0 : _k.units) !== null && _l !== void 0 ? _l : (_m = kit.detectComponent) === null || _m === void 0 ? void 0 : _m.customScale, "slides")),
                            channel.detectEnzymeAp.volume.valueUl > 0 &&
                                detailRow(channel.detectEnzymeAp.label, displayUnits((_q = (_p = (_o = kit.detectComponent) === null || _o === void 0 ? void 0 : _o.presetScale) === null || _p === void 0 ? void 0 : _p.units) !== null && _q !== void 0 ? _q : (_r = kit.detectComponent) === null || _r === void 0 ? void 0 : _r.customScale, "slides")));
                    }),
                    detect != null && detect.postProcessA.volume.valueUl > 0 &&
                        detailRow(detect.postProcessA.label, displayUnits((_2 = (_1 = (_0 = kit.detectComponent) === null || _0 === void 0 ? void 0 : _0.presetScale) === null || _1 === void 0 ? void 0 : _1.units) !== null && _2 !== void 0 ? _2 : (_3 = kit.detectComponent) === null || _3 === void 0 ? void 0 : _3.customScale, "slides")),
                    detect != null && detect.postProcessB.volume.valueUl > 0 &&
                        detailRow(detect.postProcessB.label, displayUnits((_6 = (_5 = (_4 = kit.detectComponent) === null || _4 === void 0 ? void 0 : _4.presetScale) === null || _5 === void 0 ? void 0 : _5.units) !== null && _6 !== void 0 ? _6 : (_7 = kit.detectComponent) === null || _7 === void 0 ? void 0 : _7.customScale, "slides")),
                    detect != null && detect.preHybridizationScale.volume.valueUl > 0 &&
                        detailRow(detect.preHybridizationScale.label, displayUnits((_10 = (_9 = (_8 = kit.detectComponent) === null || _8 === void 0 ? void 0 : _8.presetScale) === null || _9 === void 0 ? void 0 : _9.units) !== null && _10 !== void 0 ? _10 : (_11 = kit.detectComponent) === null || _11 === void 0 ? void 0 : _11.customScale, "slides")),
                    chromogenComponent && React.createElement(React.Fragment, null,
                        extraLabel,
                        chromogenComponent.chromogenScale.volume.valueUl > 0 &&
                            detailRow((_12 = chromogenComponent.chromogen) === null || _12 === void 0 ? void 0 : _12.label, displayUnits((_15 = (_14 = (_13 = kit.chromogenComponent) === null || _13 === void 0 ? void 0 : _13.presetScale) === null || _14 === void 0 ? void 0 : _14.units) !== null && _15 !== void 0 ? _15 : (_16 = kit.chromogenComponent) === null || _16 === void 0 ? void 0 : _16.customScale, "slides")),
                        chromogenComponent.chromogenBufferScale.volume.valueUl > 0 &&
                            detailRow((_17 = chromogenComponent.chromogenBuffer) === null || _17 === void 0 ? void 0 : _17.label, displayUnits((_20 = (_19 = (_18 = kit.chromogenComponent) === null || _18 === void 0 ? void 0 : _18.presetScale) === null || _19 === void 0 ? void 0 : _19.units) !== null && _20 !== void 0 ? _20 : (_21 = kit.chromogenComponent) === null || _21 === void 0 ? void 0 : _21.customScale, "slides")),
                        chromogenComponent.hematoxylinScale.volume.valueUl > 0 &&
                            detailRow("Hematoxylin", displayUnits((_24 = (_23 = (_22 = kit.chromogenComponent) === null || _22 === void 0 ? void 0 : _22.presetScale) === null || _23 === void 0 ? void 0 : _23.units) !== null && _24 !== void 0 ? _24 : (_25 = kit.chromogenComponent) === null || _25 === void 0 ? void 0 : _25.customScale, "slides"))),
                    misc && React.createElement(React.Fragment, null,
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, null,
                                React.createElement(Header, { className: 'chromogenic', size: 'small' }, "Other"))),
                        detailRow("Item", misc.description),
                        (misc.scaleInSlides > 0 && misc.scaleInMl.valueMl > 0) &&
                            detailRow("Scale", misc.scaleInSlides + " slides, " + misc.scaleInMl.valueWithUnit),
                        (misc.scaleInSlides > 0 && misc.scaleInMl.valueMl <= 0) &&
                            detailRow("Scale", misc.scaleInSlides + " slides"),
                        (misc.scaleInMl.valueMl > 0 && misc.scaleInSlides <= 0) &&
                            detailRow("Scale", misc.scaleInMl.valueWithUnit)));
            }
        };
        _this.organismAndTargetDisplay = function (psc) {
            return (psc != null) ?
                React.createElement(React.Fragment, null,
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Organism"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, psc.probeSet instanceof SimpleCatalogVariantProbeSet ?
                            psc.probeSet.customerOrganismName :
                            (psc.probeSet instanceof SimpleLibraryOrganismCustomTargetProbeSet ?
                                psc.probeSet.organism.displayName() :
                                psc.probeSet.organism.name))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Target"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, psc.probeSet instanceof SimpleCatalogVariantProbeSet
                            ? React.createElement("div", { className: 'gene-symbol' }, psc.probeSet.customerTargetName)
                            : React.createElement("div", { className: "gene-symbol" }, psc.probeSet.target.name))),
                    ((psc.probeSet instanceof SimpleLibraryOrganismCustomTargetProbeSet
                        || psc.probeSet instanceof SimpleOtherOrganismCustomTargetProbeSet)
                        && psc.probeSet.target.targetMrnaSeq.length > 0) &&
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth },
                                "RNA target sequence (",
                                psc.probeSet.target.targetMrnaSeq.length,
                                " nt)"),
                            React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, abbreviateRnaWithModal(psc.probeSet.target.targetMrnaSeq, true)))) : React.createElement(React.Fragment, null);
        };
        _this.otherProbeDisplay = function (probeLabel, organismAndTarget, probe) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return probe ? React.createElement(React.Fragment, null,
                probeLabel,
                organismAndTarget,
                probe.scale.pmol > 0 && React.createElement(React.Fragment, null,
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, probe.scale.labelA),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, (_b = (_a = probe.presetScale) === null || _a === void 0 ? void 0 : _a.units) !== null && _b !== void 0 ? _b : probe === null || probe === void 0 ? void 0 : probe.customScale,
                            " slides")),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, probe.scale.labelB),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, (_d = (_c = probe.presetScale) === null || _c === void 0 ? void 0 : _c.units) !== null && _d !== void 0 ? _d : probe === null || probe === void 0 ? void 0 : probe.customScale,
                            " slides")),
                    probe.probeHybridizationAScale.volume > 0 && React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, probe.probeHybridizationAScale.labelA),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, (_f = (_e = probe.presetScale) === null || _e === void 0 ? void 0 : _e.units) !== null && _f !== void 0 ? _f : probe === null || probe === void 0 ? void 0 : probe.customScale,
                            " slides")),
                    probe.probeHybridizationBScale.volume > 0 && React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, probe.probeHybridizationBScale.labelB),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, (_h = (_g = probe.presetScale) === null || _g === void 0 ? void 0 : _g.units) !== null && _h !== void 0 ? _h : probe === null || probe === void 0 ? void 0 : probe.customScale,
                            " slides")))) : React.createElement(React.Fragment, null);
        };
        _this.enzymeDisplay = function (enzymeTitle, channel) {
            return (channel != null && channel.enzyme != null) ? React.createElement(React.Fragment, null,
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, enzymeTitle),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, channel.enzyme.label))) : React.createElement(React.Fragment, null);
        };
        _this.chromogenDisplay = function (chromogenComponent) {
            var _a, _b;
            return (chromogenComponent != null) ? React.createElement(React.Fragment, null,
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Chromogen"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, (_a = chromogenComponent.chromogen) === null || _a === void 0 ? void 0 :
                        _a.label,
                        " (", (_b = chromogenComponent.chromogen) === null || _b === void 0 ? void 0 :
                        _b.enzymeCompatibility,
                        " compatible)"))) : React.createElement(React.Fragment, null);
        };
        _this.prefilledDisplay = function (amplifier) {
            return React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { className: "assay-labels", width: KitDisplay.labelWidth }, "Format"),
                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, (amplifier === null || amplifier === void 0 ? void 0 : amplifier.prefilled) ? "Ready-to-Use in Dispensers" : "Reagents Only"));
        };
        _this.automatedProProbeSet = function (admin, scaleSlides, psc, priceCents) {
            var rna = psc.probeSet instanceof SimpleCatalogVariantProbeSet ?
                psc.probeSet.variant.targetMrnaSeq : psc.probeSet.target.targetMrnaSeq;
            var accessionForBlast;
            if (psc.probeSet instanceof SimpleCatalogVariantProbeSet) {
                var simpleAccession_1 = psc.probeSet.variant.accession;
                if (simpleAccession_1 != null) {
                    var accession = psc.probeSet.probeSetFamily.accessions.find(function (a) { return a.id === simpleAccession_1.id; });
                    accessionForBlast = accession.transcriptAccession;
                    if (accession.transcriptName != null) {
                        accessionForBlast = accessionForBlast + (" (" + accession.transcriptName + ")");
                    }
                }
                else {
                    accessionForBlast = "";
                }
            }
            else {
                accessionForBlast = psc.probeSet.target.accession;
            }
            return React.createElement(Grid, { columns: 4, className: 'tight-rows' },
                admin && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { className: 'chromogenic', size: 'small' }, "HCR\u2122 Pro RNA-ISH Probe"))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Organism"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, psc.probeSet instanceof SimpleOtherOrganismCustomTargetProbeSet
                        ? psc.probeSet.organism.name
                        : psc.probeSet.organism.name + " " + (psc.probeSet.organism.scientificName.length > 0 && psc.probeSet.organism.scientificName !== psc.probeSet.organism.name ? '(' + psc.probeSet.organism.scientificName + ')' : ''))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Target"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, psc.probeSet instanceof SimpleCatalogVariantProbeSet
                        ? React.createElement("div", { className: "gene-symbol" }, psc.probeSet.probeSetFamily.geneSymbol +
                            ("" + (psc.probeSet.probeSetFamily.description.length > 0 ? ' (' + psc.probeSet.probeSetFamily.description + ')' : '')))
                        : React.createElement("div", { className: "gene-symbol" }, psc.probeSet.target.name))),
                admin && accessionForBlast !== "" && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Accession #"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, accessionSearchLink(accessionForBlast))),
                admin && rna.length > 0 && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                        "RNA target sequence (",
                        rna.length,
                        " nt)"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                        abbreviateRnaWithModal(rna, true),
                        " ",
                        _this.props.displayBlastLink &&
                            React.createElement("a", { href: blastUrl([accessionForBlast], rna) }, "Blast"))),
                admin && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Amplifier compatibility"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, psc.probeSet.hcrAmplifier.id)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                        psc.scale.labelA,
                        " / ",
                        psc.scale.detailA),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, scaleSlides)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                        psc.scale.labelB,
                        " / ",
                        psc.scale.detailB),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, scaleSlides)),
                (admin && psc.probeSet instanceof SimpleCatalogVariantProbeSet) &&
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Probe Size"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, psc.probeSet.variant.probeSetSize)),
                priceCents !== undefined && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Price"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                        "$",
                        formatMonetaryDecimal(priceCents))));
        };
        _this.proDetect = function (admin, detect, priceCents) {
            return React.createElement(Grid, { className: 'tight-rows' },
                admin && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { className: 'chromogenic', size: 'small' }, "HCR\u2122 Pro Detect"))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Format"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, detect.prefilled ? "Ready-to-Use in Dispensers" : "Reagents Only")),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Scale"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, detectScaleLabel(detect))),
                detect.channels.map(function (channel) { return React.createElement(React.Fragment, { key: channel.channel },
                    admin && channel.hcrAmplifier && React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                            "Amplifier ",
                            channel.channel),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, channel.hcrAmplifier.id)),
                    admin && channel.hapten && React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                            "Hapten ",
                            channel.channel),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, channel.hapten.name)),
                    channel.enzyme && React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                            "Enzyme ",
                            channel.channel),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, channel.enzyme.label)),
                    channel.detectAntiHapten.volume.valueUl > 0 && React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                            "Anti-Hapten ",
                            channel.channel),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, channel.detectAntiHapten.volume.valueWithUnit)),
                    channel.detectTyramide.volume.valueUl > 0 && React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                            "Tyramide ",
                            channel.channel),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, channel.detectTyramide.volume.valueWithUnit)),
                    channel.detectEnzymeAp.volume.valueUl > 0 && React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                            "Enzyme AP ",
                            channel.channel),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, channel.detectEnzymeAp.volume.valueWithUnit)),
                    channel.detectEnzymeHrp.volume.valueUl > 0 && React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                            "Enzyme HRP ",
                            channel.channel),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, channel.detectEnzymeHrp.volume.valueWithUnit))); }),
                detect.detectA.volume.valueUl > 0 && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Detect A"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, detect.detectA.volume.valueWithUnit)),
                detect.detectB.volume.valueUl > 0 && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Detect B"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, detect.detectB.volume.valueWithUnit)),
                detect.detectC.volume.valueUl > 0 && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Detect C"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, detect.detectC.volume.valueWithUnit)),
                priceCents !== undefined &&
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Price"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                            "$",
                            formatMonetaryDecimal(priceCents))));
        };
        _this.chromogenComponent = function (admin, chromogen, priceCents) {
            return React.createElement(Grid, { className: 'tight-rows' },
                admin && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { className: 'chromogenic', size: 'small' }, "Matisse\u00AE Chromogens"))),
                chromogen.chromogen && chromogen.chromogenScale.volume.valueUl > 0 && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, chromogen.chromogen.label),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, chromogen.chromogenScale.volume.valueWithUnit)),
                chromogen.chromogenBuffer && chromogen.chromogenBufferScale.volume.valueUl > 0 && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, chromogen.chromogenBuffer.label),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, chromogen.chromogenBufferScale.volume.valueWithUnit)),
                chromogen.hematoxylinScale.volume.valueUl > 0 && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Hematoxylin"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, chromogen.hematoxylinScale.volume.valueWithUnit)),
                priceCents &&
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Price"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                            "$",
                            formatMonetaryDecimal(priceCents))));
        };
        _this.automatedProMiscComponent = function (miscComponent, price) {
            return React.createElement(Grid, { className: 'tight-rows' },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { className: 'chromogenic', size: 'small' }, "Other"))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Item"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, miscComponent.description)),
                (miscComponent.scaleInSlides > 0 && miscComponent.scaleInMl.valueMl > 0) && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Scale"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                        miscComponent.scaleInSlides,
                        " slides, ",
                        miscComponent.scaleInMl.valueWithUnit)),
                (miscComponent.scaleInSlides > 0 && miscComponent.scaleInMl.valueMl <= 0) && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Scale"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                        miscComponent.scaleInSlides,
                        " slides")),
                (miscComponent.scaleInMl.valueMl > 0 && miscComponent.scaleInSlides <= 0) && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Scale"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, miscComponent.scaleInMl.valueWithUnit)),
                price &&
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Price"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                            "$",
                            formatMonetaryDecimal(price.miscComponentPriceCents))));
        };
        _this.manualProDetectComponent = function (amplifier, sampleType, chromogen, priceCents) {
            var _a, _b, _c;
            var channel = amplifier === null || amplifier === void 0 ? void 0 : amplifier.channels[0];
            return React.createElement(Grid, { className: 'tight-rows' },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { className: 'fluorescent', size: 'small' }, "HCR™ Pro Amplifier Kit"))),
                channel && React.createElement(React.Fragment, null,
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Amplifier"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, (_a = channel === null || channel === void 0 ? void 0 : channel.hcrAmplifier) === null || _a === void 0 ? void 0 : _a.id)),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Enzyme"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, (_b = channel === null || channel === void 0 ? void 0 : channel.enzyme) === null || _b === void 0 ? void 0 : _b.label))),
                chromogen && (chromogen === null || chromogen === void 0 ? void 0 : chromogen.chromogen) && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Chromogen Kit"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, (_c = chromogen === null || chromogen === void 0 ? void 0 : chromogen.chromogen) === null || _c === void 0 ? void 0 : _c.label)),
                amplifier && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Scale"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, displayScaleLabelForCart(calculateNumOfSamplesForAmp(amplifier.detectB.pmol), calculateNumOfSlidesForAmp(amplifier.detectB.pmol), "", sampleType))),
                priceCents !== undefined && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Price"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                        "$",
                        formatMonetaryDecimal(priceCents))));
        };
        _this.subtotalDisplay = function (unitSubtotalCents) {
            var _a;
            var quantity = (_a = (isKitDisplayProps1(_this.props) ? _this.props.quantity : undefined)) !== null && _a !== void 0 ? _a : 1;
            return quantifiedSubtotalDisplay(unitSubtotalCents, quantity);
        };
        _this.subtotalLabel = function () {
            var _a;
            return (_a = _this.props.subtotalLabel) !== null && _a !== void 0 ? _a : "Subtotal (USD)";
        };
        _this.optionallyPriceKit = function () {
            if (isKitDisplayProps1(_this.props)) {
                if (_this.props.pricedKit instanceof RnaFishPricedKit) {
                    return new OptionallyPriceRnaFishKit(_this.props.pricedKit.kit, _this.props.pricedKit.price);
                }
                else if (_this.props.pricedKit instanceof SecondaryIfPricedKit) {
                    return new OptionallyPriceSecondaryIfKit(_this.props.pricedKit.kit, _this.props.pricedKit.price);
                }
                else if (_this.props.pricedKit instanceof PricedManualProKit) {
                    return new OptionallyPriceManualPro(_this.props.pricedKit.kit, _this.props.pricedKit.price);
                }
                else if (_this.props.pricedKit instanceof ManualGoldIfPricedKit) {
                    return new OptionallyPriceManualGoldIfKit(_this.props.pricedKit.kit, _this.props.pricedKit.price);
                }
                else if (_this.props.pricedKit instanceof AutomatedGoldIfPricedKit) {
                    return new OptionallyPriceAutomatedGoldIfKit(_this.props.pricedKit.kit, _this.props.pricedKit.price);
                }
                return new OptionallyPriceRnaCishKit(_this.props.pricedKit.kit, _this.props.pricedKit.price);
            }
            else {
                if (_this.props.kit instanceof RnaFishKit) {
                    return new OptionallyPriceRnaFishKit(_this.props.kit, undefined);
                }
                else if (_this.props.kit instanceof SecondaryIfKit) {
                    return new OptionallyPriceSecondaryIfKit(_this.props.kit, undefined);
                }
                else if (_this.props.kit instanceof ManualProKit) {
                    return new OptionallyPriceManualPro(_this.props.kit, undefined);
                }
                else if (_this.props.kit instanceof ManualGoldIfKit) {
                    return new OptionallyPriceManualGoldIfKit(_this.props.kit, undefined);
                }
                else if (_this.props.kit instanceof AutomatedGoldIfKit) {
                    return new OptionallyPriceAutomatedGoldIfKit(_this.props.kit, undefined);
                }
                return new OptionallyPriceRnaCishKit(_this.props.kit, undefined);
            }
        };
        _this.onCopyClick = function (rna) {
            var n = navigator;
            n.clipboard.writeText(rna)
                .then(function () {
                _this.setState({
                    copyButtonText: 'Copied!'
                });
                setTimeout(function () { return _this.setState({
                    copyButtonText: 'Copy'
                }); }, 2000);
            })
                .catch(function (e) {
                console.log("Could not copy: " + e);
            });
        };
        _this.state = {
            copyButtonText: 'Copy'
        };
        return _this;
    }
    KitDisplay.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        var priceKit = this.optionallyPriceKit();
        if (priceKit instanceof OptionallyPriceRnaFishKit) {
            var legacy = priceKit.kit.legacy;
            if (isNegativeControlRnaFish(priceKit.kit)) {
                return React.createElement("div", { className: 'kit-display' }, this.negativeControlProbe(priceKit.kit.legacy, priceKit.kit.probeSetComponent, priceKit.kit.probeSetComponent.probeSet, priceKit.kit.sampleType, (_a = priceKit.price) === null || _a === void 0 ? void 0 : _a.probeSetPriceCents));
            }
            return React.createElement("div", { className: 'kit-display' },
                React.createElement(Grid, { className: 'tight-rows' },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, priceKit.kit.sampleType.label))),
                priceKit.kit.probeSetComponent
                    && this.probeSet(legacy, this.props.displayBlastLink, priceKit.kit.probeSetComponent, priceKit.kit.sampleType, (_b = priceKit.price) === null || _b === void 0 ? void 0 : _b.probeSetPriceCents),
                priceKit.kit.amplifierComponent
                    && this.amplifier(legacy, priceKit.kit.amplifierComponent, priceKit.kit.sampleType, (_c = priceKit.price) === null || _c === void 0 ? void 0 : _c.amplifierPriceCents),
                priceKit.kit.buffersComponent
                    && this.buffers(legacy, priceKit.kit.buffersComponent, (_d = priceKit.price) === null || _d === void 0 ? void 0 : _d.buffersPriceCents),
                React.createElement(Divider, null),
                React.createElement(Grid, { className: 'tight-rows' },
                    React.createElement(Grid.Row, { width: KitDisplay.labelWidth },
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Comment"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, priceKit.kit.comment)),
                    priceKit.price && React.createElement(Grid.Row, { width: KitDisplay.labelWidth },
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, this.subtotalLabel()),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.subtotalDisplay(priceKit.price.subtotalCents)))));
        }
        else if (priceKit instanceof OptionallyPriceSecondaryIfKit) {
            var legacy = priceKit.kit.legacy;
            return React.createElement("div", { className: 'kit-display' },
                React.createElement(Grid, { className: 'tight-rows' },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, priceKit.kit.sampleType.label))),
                priceKit.kit.probeComponent && this.secondaryIfProbe(priceKit.kit.probeComponent, priceKit.kit.sampleType, legacy, (_e = priceKit.price) === null || _e === void 0 ? void 0 : _e.probePriceCents),
                priceKit.kit.amplifierComponent && this.amplifier(legacy, priceKit.kit.amplifierComponent, priceKit.kit.sampleType, (_f = priceKit.price) === null || _f === void 0 ? void 0 : _f.amplifierPriceCents),
                priceKit.kit.buffersComponent && this.secondaryIfBuffers(legacy, priceKit.kit.buffersComponent, (_g = priceKit.price) === null || _g === void 0 ? void 0 : _g.buffersPriceCents),
                React.createElement(Divider, null),
                React.createElement(Grid, { className: 'tight-rows' },
                    React.createElement(Grid.Row, { width: KitDisplay.labelWidth },
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Comment"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, priceKit.kit.comment)),
                    priceKit.price && React.createElement(Grid.Row, { width: KitDisplay.labelWidth },
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, this.subtotalLabel()),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.subtotalDisplay(priceKit.price.subtotalCents)))));
        }
        else if (priceKit instanceof OptionallyPriceManualGoldIfKit) {
            return React.createElement("div", { className: 'kit-display' },
                React.createElement(Grid, { className: 'tight-rows' },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, priceKit.kit.sampleType.label))),
                priceKit.kit.encoderComponent && this.encoderComponent(priceKit.kit.encoderComponent, priceKit.kit.sampleType, (_h = priceKit.price) === null || _h === void 0 ? void 0 : _h.encoderPriceCents),
                priceKit.kit.amplifierComponent && this.amplifier(false, priceKit.kit.amplifierComponent, priceKit.kit.sampleType, (_j = priceKit.price) === null || _j === void 0 ? void 0 : _j.amplifierPriceCents),
                priceKit.kit.buffersComponent && this.encoderBuffers(priceKit.kit.buffersComponent, (_k = priceKit.price) === null || _k === void 0 ? void 0 : _k.buffersPriceCents),
                React.createElement(Divider, null),
                React.createElement(Grid, { className: 'tight-rows' },
                    React.createElement(Grid.Row, { width: KitDisplay.labelWidth },
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Comment"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, priceKit.kit.comment)),
                    priceKit.price && React.createElement(Grid.Row, { width: KitDisplay.labelWidth },
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, this.subtotalLabel()),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.subtotalDisplay(priceKit.price.subtotalCents)))));
        }
        else if (priceKit instanceof OptionallyPriceRnaCishKit) {
            return React.createElement("div", { className: 'kit-display' },
                React.createElement(Grid, { className: 'tight-rows' },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, null,
                            React.createElement(Header, { className: 'chromogenic', size: 'medium' }, "HCR\u2122 Pro RNA-ISH")))),
                !this.props.admin &&
                    this.consumerRnaCishKit(priceKit.kit.platform, priceKit.kit.config, priceKit.kit),
                this.props.admin && priceKit.kit.probeSetComponent.map(function (psc) {
                    var _a, _b, _c, _d;
                    return _this.automatedProProbeSet(_this.props.admin, ((_a = psc.presetScale) === null || _a === void 0 ? void 0 : _a.units) + " " + ((_b = psc.presetScale) === null || _b === void 0 ? void 0 : _b.unitsLabel), psc, (_d = (_c = priceKit.price) === null || _c === void 0 ? void 0 : _c.probeSetPriceCents.find(function (price) { return price.channel === psc.channel; })) === null || _d === void 0 ? void 0 : _d.price);
                }),
                this.props.admin && priceKit.kit.detectComponent && this.proDetect(this.props.admin, priceKit.kit.detectComponent, (_l = priceKit.price) === null || _l === void 0 ? void 0 : _l.detectPriceCents),
                this.props.admin && priceKit.kit.chromogenComponent && this.chromogenComponent(this.props.admin, priceKit.kit.chromogenComponent, (_m = priceKit.price) === null || _m === void 0 ? void 0 : _m.chromogenPriceCents),
                this.props.admin && priceKit.kit.miscComponent && this.automatedProMiscComponent(priceKit.kit.miscComponent, priceKit.price),
                React.createElement(Divider, null),
                React.createElement(Grid, { className: 'tight-rows' },
                    React.createElement(Grid.Row, { width: KitDisplay.labelWidth },
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Comment"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, priceKit.kit.comment)),
                    priceKit.kit.reasonForOther.length > 0 && React.createElement(Grid.Row, { width: KitDisplay.labelWidth },
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Reason For Other"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, priceKit.kit.reasonForOther)),
                    priceKit.price && React.createElement(Grid.Row, { width: KitDisplay.labelWidth },
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, this.subtotalLabel()),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.subtotalDisplay(priceKit.price.subtotalCents)))));
        }
        else if (priceKit instanceof OptionallyPriceAutomatedGoldIfKit) {
            return React.createElement("div", { className: 'kit-display' },
                React.createElement(Grid, { className: 'tight-rows' },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, null,
                            React.createElement(Header, { size: 'medium' }, "HCR\u2122 Gold IF (Automated)"))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, priceKit.kit.sampleType.label)),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Platform"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, priceKit.kit.platform.label)),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Plexity"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                            priceKit.kit.plexity,
                            "-plex")),
                    priceKit.kit.presetScale && React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Scale"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                            priceKit.kit.presetScale.units,
                            " ",
                            priceKit.kit.presetScale.unitsLabel))),
                priceKit.kit.encoderComponent && React.createElement(Grid, { className: 'tight-rows' },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: 16 },
                            React.createElement(Header, { size: 'small' }, "HCR\u2122 HiFi Encoder"))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Primary Species"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, priceKit.kit.encoderComponent.encoderAmpPairs
                            .map(function (pair, index) { return (React.createElement("div", { key: index },
                            pair.primarySpecies.displayName,
                            " (",
                            pair.hcrAmplifier.id,
                            ")")); }))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Encoder Scale"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                            priceKit.kit.encoderComponent.encoderScaleUl,
                            " \u00B5L")),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Antibody Block"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                            priceKit.kit.encoderComponent.antibodyBlockMl,
                            " mL")),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Antibody Diluent"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                            priceKit.kit.encoderComponent.antibodyDiluentMl,
                            " mL")),
                    priceKit.price && React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Encoder Price"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                            "$",
                            formatMonetaryDecimal(priceKit.price.encoderPriceCents)))),
                priceKit.kit.detectComponent && React.createElement(Grid, { className: 'tight-rows' },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: 16 },
                            React.createElement(Header, { size: 'small' }, "HCR\u2122 Detect"))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "HCR\u2122 Gold Amplifier"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, priceKit.kit.detectComponent.ampLabelPairs
                            .map(function (pair, index) { return (React.createElement("div", { key: index },
                            pair.hcrAmplifier.id,
                            "-",
                            pair.fluorophore.name)); }))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Detect A"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                            priceKit.kit.detectComponent.detectAMl,
                            " mL")),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Detect B"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                            priceKit.kit.detectComponent.detectBMl,
                            " mL")),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Detect C"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                            priceKit.kit.detectComponent.detectCMl,
                            " mL")),
                    priceKit.price && React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Detect Price"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                            "$",
                            formatMonetaryDecimal(priceKit.price.detectPriceCents)))),
                React.createElement(Divider, null),
                React.createElement(Grid, { className: 'tight-rows' },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Comment"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, priceKit.kit.comment)),
                    priceKit.price && React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, this.subtotalLabel()),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.subtotalDisplay(priceKit.price.subtotalCents)))));
        }
        else {
            var probeSet = priceKit.kit.probeSet;
            var probeSetPrice = (_o = priceKit.price) === null || _o === void 0 ? void 0 : _o.probeSetPriceCents;
            var detect = priceKit.kit.detect;
            var detectPrice = (_p = priceKit.price) === null || _p === void 0 ? void 0 : _p.detectPriceCents;
            var chromogen = priceKit.kit.chromogen;
            var chromogenPrice = (_q = priceKit.price) === null || _q === void 0 ? void 0 : _q.chromogenPriceCents;
            var manualProBuffer = priceKit.kit.buffers;
            var manualProBufferPrice = (_r = priceKit.price) === null || _r === void 0 ? void 0 : _r.buffersPriceCents;
            if (probeSet && probeSet.scale.scaleValue === 50 && !detect && !chromogen && !manualProBuffer && isNegativeControlManualPro(probeSet)) {
                return React.createElement("div", { className: 'kit-display' }, this.negativeControlProbe(false, probeSet, probeSet.probeSet, priceKit.kit.sampleType, probeSetPrice));
            }
            return React.createElement("div", { className: 'kit-display' },
                React.createElement(Grid, { className: 'tight-rows' },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, priceKit.kit.sampleType.label))),
                probeSet && this.probeSet(false, this.props.displayBlastLink, probeSet, priceKit.kit.sampleType, probeSetPrice),
                !this.props.admin && (detect || chromogen) && this.manualProDetectComponent(detect, priceKit.kit.sampleType, chromogen, addNullableValues(detectPrice, chromogenPrice)),
                this.props.admin && detect && this.proDetect(this.props.admin, detect, detectPrice),
                this.props.admin && chromogen && this.chromogenComponent(this.props.admin, chromogen, chromogenPrice),
                manualProBuffer && this.manualProBuffers(manualProBuffer, manualProBufferPrice),
                React.createElement(Divider, null),
                React.createElement(Grid, { className: 'tight-rows' },
                    React.createElement(Grid.Row, { width: KitDisplay.labelWidth },
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Comment"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, priceKit.kit.comment)),
                    priceKit.price && React.createElement(Grid.Row, { width: KitDisplay.labelWidth },
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, this.subtotalLabel()),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.subtotalDisplay(priceKit.price.subtotalCents)))));
        }
    };
    KitDisplay.labelWidth = 5;
    KitDisplay.valueWidth = 11;
    return KitDisplay;
}(React.PureComponent));
export default KitDisplay;
/**
 * The one shared renderer for line subtotals: "$1,020.00 (2 @ $510.00 each)" for
 * multi-quantity lines, plain "$510.00" otherwise.
 */
export var quantifiedSubtotalDisplay = function (unitSubtotalCents, quantity) {
    if (quantity <= 1) {
        return "$" + formatMonetaryDecimal(unitSubtotalCents);
    }
    return React.createElement(React.Fragment, null,
        "$",
        formatMonetaryDecimal(unitSubtotalCents * quantity),
        React.createElement("span", { style: { marginLeft: '0.75em', color: '#707070' } },
            "(",
            quantity,
            " @ $",
            formatMonetaryDecimal(unitSubtotalCents),
            " each)"));
};
// Small helper to encapsulate the nested checks for the Bacillus/dapB
// negative-control special case.
export var isNegativeControlRnaFish = function (kit) {
    var psComp = kit.probeSetComponent;
    // must have only a probeSetComponent and no channel/buffers
    if (!psComp || psComp.scale.scaleValue !== 50 || kit.amplifierComponent !== undefined || kit.buffersComponent !== undefined) {
        return false;
    }
    var probeSet = psComp.probeSet;
    if (!(probeSet instanceof SimpleCatalogVariantProbeSet)) {
        return false;
    }
    return probeSet.organism.name === "Bacillus subtilis" && probeSet.probeSetFamily.geneSymbol === "dapB";
};
export var isNegativeControlManualPro = function (psc) {
    var probeSet = psc.probeSet;
    if (!(probeSet instanceof SimpleCatalogVariantProbeSet)) {
        return false;
    }
    return probeSet.organism.name === "Bacillus subtilis" && probeSet.probeSetFamily.geneSymbol === "dapB";
};
// tslint:disable-next-line:max-classes-per-file
var OptionallyPriceRnaFishKit = /** @class */ (function () {
    function OptionallyPriceRnaFishKit(kit, price) {
        this.kit = kit;
        this.price = price;
    }
    return OptionallyPriceRnaFishKit;
}());
// tslint:disable-next-line:max-classes-per-file
var OptionallyPriceSecondaryIfKit = /** @class */ (function () {
    function OptionallyPriceSecondaryIfKit(kit, price) {
        this.kit = kit;
        this.price = price;
    }
    return OptionallyPriceSecondaryIfKit;
}());
var OptionallyPriceManualGoldIfKit = /** @class */ (function () {
    function OptionallyPriceManualGoldIfKit(kit, price) {
        this.kit = kit;
        this.price = price;
    }
    return OptionallyPriceManualGoldIfKit;
}());
var OptionallyPriceRnaCishKit = /** @class */ (function () {
    function OptionallyPriceRnaCishKit(kit, price) {
        this.kit = kit;
        this.price = price;
    }
    return OptionallyPriceRnaCishKit;
}());
var OptionallyPriceManualPro = /** @class */ (function () {
    function OptionallyPriceManualPro(kit, price) {
        this.kit = kit;
        this.price = price;
    }
    return OptionallyPriceManualPro;
}());
// tslint:disable-next-line:max-classes-per-file
var OptionallyPriceAutomatedGoldIfKit = /** @class */ (function () {
    function OptionallyPriceAutomatedGoldIfKit(kit, price) {
        this.kit = kit;
        this.price = price;
    }
    return OptionallyPriceAutomatedGoldIfKit;
}());
var isKitDisplayProps1 = function (b) {
    return b.pricedKit !== undefined;
};
var displayUnits = function (units, label) {
    return units !== undefined && label ? units + " " + label : "";
};
var probeScaleLabel = function (psc) {
    return (psc === null || psc === void 0 ? void 0 : psc.presetScale) ? displayUnits(psc.presetScale.units, psc.presetScale.unitsLabel)
        : (psc === null || psc === void 0 ? void 0 : psc.customScale) ? psc.customScale + " slides"
            : "";
};
var detectScaleLabel = function (detect) {
    return (detect === null || detect === void 0 ? void 0 : detect.presetScale) ? displayUnits(detect.presetScale.units, detect.presetScale.unitsLabel)
        : (detect === null || detect === void 0 ? void 0 : detect.customScale) ? detect.customScale + " slides"
            : "";
};
var chromogenScaleLabel = function (chromogen) {
    return (chromogen === null || chromogen === void 0 ? void 0 : chromogen.presetScale) ? displayUnits(chromogen.presetScale.units, chromogen.presetScale.unitsLabel)
        : (chromogen === null || chromogen === void 0 ? void 0 : chromogen.customScale) ? chromogen.customScale + " slides"
            : "";
};
export var abbreviateRnaWithModal = function (rnaSeq, includeCopyButton) {
    if (rnaSeq.length <= 40) {
        return React.createElement("span", null,
            rnaSeq,
            " ");
    }
    else {
        return React.createElement(React.Fragment, null,
            React.createElement("span", null, rnaSeq.substr(0, 20) + '…' + rnaSeq.substr(rnaSeq.length - 20, 20)),
            " ",
            includeCopyButton && copyButton(rnaSeq));
    }
};
var copyButton = function (rnaSeq) {
    var handler = function () {
        // navigator.clipboard isn't exposed in TS yet
        var n = navigator;
        n.clipboard.writeText(rnaSeq)
            .catch(function (e) {
            console.log("Could not copy: " + e);
        });
    };
    return React.createElement(Button, { icon: 'copy', size: 'mini', onClick: handler });
};
export var rnaModal = function (rnaSeq, label) {
    return React.createElement(Modal, { trigger: React.createElement(Button, { label: label, icon: 'search plus', size: 'mini' }), closeIcon: true },
        React.createElement(Modal.Header, null,
            "RNA target sequence (",
            rnaSeq.length,
            " nt)"),
        React.createElement(Modal.Content, null,
            React.createElement("span", { style: { 'overflowWrap': 'break-word', 'fontFamily': 'monospace' } }, rnaSeq)));
};
export var accessionSearchLink = function (accession) {
    return React.createElement("a", { href: "https://www.ncbi.nlm.nih.gov/nuccore/?term=" + encodeURIComponent(accession), target: '_blank' }, accession);
};
export var compactRnaCishAccessionsListWithPopup = function (accessions) {
    if (accessions.length === 0) {
        return noAccessionsMsg;
    }
    else if (accessions.length === 1) {
        // don't bother truncating here, we have more real estate
        return accessionSearchLink(accessions[0].transcriptAccession);
    }
    else {
        return React.createElement(React.Fragment, null,
            accessions[0].transcriptAccession,
            ", \u2026 ",
            rnaCishAccessionsPopup(accessions));
    }
};
var blastUrl = function (accessions, rna) {
    return "https://blast.ncbi.nlm.nih.gov/Blast.cgi?PAGE_TYPE=BlastSearch&USER_FORMAT_DEFAULTS=on&SET_SAVED_SEARCH=true&PAGE=Nucleotides&PROGRAM=blastn&QUERY=" + encodeURIComponent(accessions.join("\n")) + "&SUBJECTS=" + encodeURIComponent(rna) + "&JOB_TITLE=" + encodeURIComponent(accessions.join(", ")) + "&GAPCOSTS=5%202&MATCH_SCORES=2,-3&BLAST_SPEC=blast2seq&DATABASE=&BLAST_PROGRAMS=blastn&MAX_NUM_SEQ=100&SHORT_QUERY_ADJUST=on&EXPECT=10&WORD_SIZE=11&REPEATS=repeat_9606&TEMPLATE_TYPE=0&TEMPLATE_LENGTH=18&FILTER=L&FILTER=m&PROG_DEFAULTS=on&SHOW_OVERVIEW=on&SHOW_LINKOUT=on&ALIGNMENT_VIEW=Pairwise&MASK_CHAR=2&MASK_COLOR=1&GET_SEQUENCE=on&NUM_OVERVIEW=100&DESCRIPTIONS=100&ALIGNMENTS=100&FORMAT_OBJECT=Alignment&FORMAT_TYPE=HTML";
};
export var numOfBindingSitesDisplay = function (pss) {
    if (pss === 1) {
        return "Special (1)";
    }
    else if (pss > 1 && pss <= 20) {
        return "Standard (Up to 20)";
    }
    else {
        return "Boosted (Up to 40)";
    }
};
export var numOfBindingSites = function (pss) {
    if (pss === 1) {
        return 1;
    }
    else if (pss > 1 && pss <= 20) {
        return 20;
    }
    else {
        return 40;
    }
};
export var addNullableValues = function () {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    // Check if all values are undefined
    if (values.every(function (v) { return v === undefined; })) {
        return undefined;
    }
    // Otherwise, sum them, treating undefined as 0
    return values.reduce(function (sum, v) { return sum + (v !== null && v !== void 0 ? v : 0); }, 0);
};
var formatAmplifierLabel = function (amplifier) {
    var labelName = amplifier.label.name.trim();
    return labelName.length > 0 ? amplifier.hcrAmplifier.id + "-" + labelName : amplifier.hcrAmplifier.id;
};
//# sourceMappingURL=KitDisplay.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/rna-fish/KitDisplay.js
// module id = 42
// module chunks = 0